import { rejectInvalidSyncKey } from 'serviceWorker/services/factories/invalidSyncKey';
import { DocumentationInDto } from 'shared/dtos/in/documentation';
import {
  defaultConfig,
  generateHeaders,
  makeNormalizePagedResponse,
  makeNormalizeResponse,
} from '../../helpers/httpRequests';
import {
  HeadersData,
  NormalizedEntityResponseData,
  NormalizedPagedEntityResponseData,
} from '../factories/types';
import { pull } from '../pull';

const parseResponse = makeNormalizeResponse<DocumentationInDto>('items');
const parsePagedResponse =
  makeNormalizePagedResponse<DocumentationInDto>('items');

export const fetchDocumentationsPaged = (
  data: HeadersData,
  controller: AbortController,
  offset: number,
  size: number
):
  | Promise<NormalizedPagedEntityResponseData<DocumentationInDto>>
  | undefined => {
  const { signal } = controller;
  if (shouldSkip(data, signal)) {
    return;
  }
  const builtUrl = `${data.api}/v2/project/${data.projectId}/documentation?offset=${offset}&size=${size}`;

  return pull(builtUrl, {
    ...defaultConfig,
    cache: 'default',
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  }).then(parsePagedResponse);
};

export const fetchUpdatedDocumentations = (
  data: HeadersData,
  syncKey: string,
  controller: AbortController
):
  | Promise<NormalizedEntityResponseData<DocumentationInDto>>
  | undefined => {
  const { signal } = controller;
  if (!data.api || !data.projectId) {
    //not enough data, skip.
    return;
  }
  const builtUrl = `${data.api}/v2/project/${
    data.projectId
  }/documentation?syncKey=${encodeURIComponent(syncKey)}`;

  return pull(builtUrl, {
    ...defaultConfig,
    method: 'GET',
    headers: generateHeaders(data),
    signal,
  })
    .then((response: Response) => rejectInvalidSyncKey(response, 'documentations'))
    .then(parseResponse);
};

function shouldSkip(data: HeadersData, signal: AbortSignal): boolean {
  return !data.api || !data.projectId || signal.aborted;
}
